// extracted by mini-css-extract-plugin
export default {"buttons":"BoxButtons_buttons__L1+80","buttons--override":"BoxButtons_buttons--override__rgn1A"};